import { post } from './http'
import global from '@/api/global'
var name = global.smpName
// ---------------字典管理---------------------
// 字典管理--字典列表--新增
export const dictionaryAdd = p => post(name + '/bSpuDictionary/add', p)
// 字典管理--字典列表--修改
export const dictionaryChange = p => post(name + '/bSpuDictionary/update', p)
// 字典管理--字典列表--查询
export const dictionarySearch = p => post(name + '/bSpuDictionary/list', p)
// 字典管理--字典列表--组名下拉框
export const dictionarySelect = p => post(name + '/bSpuDictionary/listByGroupType', p)
// 字典管理--字典列表--删除
export const dictionaryDelete = p => post(name + '/bSpuDictionary/delete', p)
// ---------------组名维护---------------------
// 组名维护--新增
export const addGroupType = p => post(name + '/bSpuDictionary/addGroupType', p)
// 组名维护--修改
export const updateGroupType = p => post(name + '/bSpuDictionary/updateGroupType', p)
// 组名维护--删除
export const deleteGroupType = p => post(name + '/bSpuDictionary/delete', p)
// 组名维护--查看
export const seeGroupType = p => post(name + '/bSpuDictionary/listByGroupNoCommon', p)
// ---------------spu页面----------------------
// spu新增
export const spuAdd = p => post(name + '/spuinfo/add', p)
// spu查询列表
export const spuSearch = p => post(name + '/spuinfo/list', p)
// spu状态
export const spuStatus = p => post(name + '/spuinfo/updateStatus', p)
// spu修改
export const spuUpdate = p => post(name + '/spuinfo/update', p)
// spu删除
export const spuDelete = p => post(name + '/spuinfo/delete', p)
// spu属性列表
export const spuAttributeList = p => post(name + '/spuattribute/list', p)
// spu属性-新增
export const spuAttributeAdd = p => post(name + '/spuattribute/add', p)
// spu属性-修改
export const spuAttributeUpdate = p => post(name + '/spuattribute/update', p)
// spu属性-删除
export const spuAttributeDelete = p => post(name + '/spuattribute/delete', p)
// -----------------sku页面-----------------------
export const skuList = p => post(name + '/skuinfo/list', p)
// sku页面表头
export const skuTableHead = p => post(name + '/skuinfo/tableHead', p)
// sku页面新增
export const skuAdd = p => post(name + '/skuinfo/add', p)
// sku页面修改
export const skuUpdate = p => post(name + '/skuinfo/update', p)
// sku页面删除
export const skuDelete = p => post(name + '/skuinfo/delete', p)
// sku页面启用/停用
export const skuUpdateStatus = p => post(name + '/skuinfo/updateStatus', p)
// 判断sku页面有无数据
export const skuCheckSkuExist = p => post(name + '/skuinfo/checkSkuExist', p)
// 校验spu属性存不存在
export const skuCheckExist = p => post(name + '/spuattribute/checkExist', p)
